import { render } from "./NavigationBar.vue?vue&type=template&id=defe2486&scoped=true&ts=true"
import script from "./NavigationBar.vue?vue&type=script&lang=ts"
export * from "./NavigationBar.vue?vue&type=script&lang=ts"

import "./NavigationBar.vue?vue&type=style&index=0&id=defe2486&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-defe2486"]])

export default __exports__